export default "__VITE_ASSET__B5NtC8lF__"